const ITEM_PER_PAGE = 10;

export {
    ITEM_PER_PAGE
}